module.exports = __webpack_public_path__ + "static/media/logo.275ea08a.png";